const Views = self => ({
  get time() {
    // eslint-disable-next-line radix
    return parseInt(Date.now() / 1000, 0) - self.timestamp;
  },
});

export default Views;
